<template>
  <div id="sersdss">
    <Form :label-width="80">
      <FormItem label="周期设置">
        <CheckboxGroup v-model="formItem.days">
          <Checkbox
            v-for="(item, index) in days"
            :key="index"
            :label="item.label"
            >{{ item.name }}</Checkbox
          >
        </CheckboxGroup></FormItem
      ></Form
    >

    <Form :label-width="80"
      ><Row :gutter="16">
        <Col span="12" v-for="(item, index) in formItem.times" :key="index"
          ><FormItem :label="'第' + (index + 1) + '区间'">
            <TimePicker
              format="HH:mm"
              type="timerange"
              placement="bottom-end"
              placeholder="Select time"
              :clearable="false"
              v-model="formItem.times[index]" /></FormItem
        ></Col>
      </Row>
    </Form>

    <Button type="success" @click="zengjia">增加区间</Button
    ><Button @click="jianshao">减少区间</Button>

    <Button type="primary" @click="submit" style="float: right"
      >设置好了</Button
    >
  </div>
</template>
<script>
export default {
  data() {
    return {
      days: [
        { label: 0, name: "周日" },
        { label: 1, name: "周一" },
        { label: 2, name: "周二" },
        { label: 3, name: "周三" },
        { label: 4, name: "周四" },
        { label: 5, name: "周五" },
        { label: 6, name: "周六" },
      ],
      hour: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
      ],
      mins: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "50",
        "51",
        "52",
        "53",
        "54",
        "55",
        "56",
        "57",
        "58",
        "59",
      ],
      formItem: {
        days: [],
        times: [],
      },
    };
  },
  methods: {
    reData(v) {
      console.log(v);
      this.formItem = v;
    },
    check() {
      var a = this.formItem.times;
      for (let i = 0; i < a.length; i++) {
        if (a[i][0] == a[i][1]) {
          this.$Message.error({
            content: "有起始相等的区间，请修改",
            duration: 3,
          });
          return;
        }
        if (i + 1 < a.length) {
          var max = [a[i][0], a[i + 1][0]];
          var min = [a[i][1], a[i + 1][1]];
          if (Math.max.apply(null, max) <= Math.min.apply(null, min)) {
            this.$Message.error({
              content: "有交叉区间，请修改",
              duration: 3,
            });
            return;
          }
        }
      }
      return true;
    },
    jianshao() {
      this.formItem.times.splice(this.formItem.times.length - 1, 1);
    },
    zengjia() {
      this.formItem.times.push(["08:00", "18:00"]);
    },
    submit() {
      this.$emit("zhouqi", this.formItem);
    },
  },
  mounted() {},
};
</script>
<style lang="">
#sersdss .days123 {
  margin-bottom: 20px;
  display: flex;
}
</style>


// WEBPACK FOOTER //
// src/components/rule/zhouqi.vue